export default "__VITE_ASSET__Dh4LK7oa__"